import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, TextInput, ScrollView, Alert } from 'react-native';
import { User } from '../types';
import { styles } from '../styles';

interface PatientDetailViewProps {
  user: User;
  onBack: () => void;
  onUserUpdate: (user: User) => void;
}

export function PatientDetailView({ user, onBack, onUserUpdate }: PatientDetailViewProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedUser, setEditedUser] = useState<User>(user);

  useEffect(() => {
    setEditedUser(user);
  }, [user]);

  const handleSave = () => {
    onUserUpdate(editedUser);
    setIsEditing(false);
    Alert.alert('Erfolgreich', 'Patientendaten wurden gespeichert.');
  };

  const renderField = (label: string, field: keyof User, keyboardType: 'default' | 'email-address' | 'phone-pad' = 'default') => (
    <View style={styles.detailField}>
      <Text style={styles.detailFieldLabel}>{label}</Text>
      {isEditing ? (
        <TextInput
          style={styles.detailInput}
          value={String(editedUser[field] as string || '')}
          onChangeText={(text) => setEditedUser({ ...editedUser, [field]: text } as any)}
          keyboardType={keyboardType}
        />
      ) : (
        <Text style={styles.detailFieldValue}>{String(user[field] as string || '')}</Text>
      )}
    </View>
  );

  return (
    <ScrollView style={styles.detailContainer}>
      <View style={styles.detailHeader}>
        <TouchableOpacity onPress={onBack} style={styles.backButton}>
          <Text style={styles.backButtonText}>← Zurück</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.saveButton} onPress={() => isEditing ? handleSave() : setIsEditing(true)}>
          <Text style={styles.saveButtonText}>{isEditing ? 'Speichern' : 'Bearbeiten'}</Text>
        </TouchableOpacity>
      </View>

      <View style={styles.detailProfile}>
        <View style={styles.detailAvatar}>
          <Text style={styles.detailAvatarText}>{user.name.charAt(0)}</Text>
        </View>
        <Text style={styles.detailName}>{isEditing ? editedUser.name : user.name}</Text>
      </View>

      {renderField('E-Mail', 'email', 'email-address')}
      {renderField('Telefon', 'phone', 'phone-pad')}
      {renderField('Geburtsdatum', 'birthdate')}
      {renderField('Adresse', 'address')}
      {renderField('Krankenkasse', 'insurance')}
      {renderField('Versicherungsnummer', 'insuranceNumber')}
      {renderField('MXID', 'mxid')}
      
      <View style={styles.detailField}>
        <Text style={styles.detailFieldLabel}>Notizen</Text>
        {isEditing ? (
          <TextInput
            style={[styles.detailInput, styles.notesInput]}
            value={editedUser.notes || ''}
            onChangeText={(text) => setEditedUser({ ...editedUser, notes: text } as any)}
            multiline
          />
        ) : (
          <Text style={styles.detailFieldValue}>{user.notes || 'Keine Notizen'}</Text>
        )}
      </View>
    </ScrollView>
  );
}
